import { render, staticRenderFns } from "./SolicitacaoListagemHeader.vue?vue&type=template&id=4dd7f465"
import script from "./SolicitacaoListagemHeader.vue?vue&type=script&lang=js"
export * from "./SolicitacaoListagemHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports